<template>
  <div class="row g-3 mb-3">
    <div class="col-md-3">
      <label class="form-label">{{ $t("logNivel") }}</label>
      <select v-model="filters.level" class="form-select">
        <option value="todos">
          {{ $t("todos") }}
        </option>
        <option value="error">
          Error
        </option>
        <option value="warn">
          Warn
        </option>
        <option value="info">
          Info
        </option>
        <option value="debug">
          Debug
        </option>
      </select>
    </div>

    <div class="col-md-6">
      <label class="form-label">{{ $t("pesquisar") }}</label>
      <input
        v-model="filters.search"
        type="text"
        class="form-control"
        maxlength="120"
        :placeholder="$t('logFiltrarTexto')"
      >
    </div>

    <div class="col-md-3 d-flex align-items-end justify-content-md-end">
      <button class="btn btn-outline-secondary" type="button" @click="limpar">
        {{ $t("logLimparTela") }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  emits: ['filter', 'clear'],
  data: () => ({
    filters: {
      level: 'todos',
      search: '',
    },
  }),
  watch: {
    filters: {
      handler() {
        this.$emit('filter', this.filters);
      },
      deep: true,
    },
  },
  mounted() {
    this.$emit('filter', this.filters);
  },
  methods: {
    limpar() {
      this.filters = {
        level: 'todos',
        search: '',
      };
      this.$emit('filter', this.filters);
      this.$emit('clear');
    },
  },
};
</script>
